import memoize from 'memoize-one';

function fromReduxState(func) {
  // Shallow comparison is enough as reducers recreate a new dict each time they are modified.
  return memoize(func);
}

export default fromReduxState;
